﻿(function () {
  'use strict';

  var PAPER_SIZES = {
    A5: { label: 'A5 (148 x 210 mm)', width: 148, height: 210 },
    A4: { label: 'A4 (210 x 297 mm)', width: 210, height: 297 },
    A3: { label: 'A3 (297 x 420 mm)', width: 297, height: 420 },
    A2: { label: 'A2 (420 x 594 mm)', width: 420, height: 594 },
    A1: { label: 'A1 (594 x 841 mm)', width: 594, height: 841 },
    Letter: { label: 'US Letter (215.9 x 279.4 mm)', width: 215.9, height: 279.4 },
    Legal: { label: 'US Legal (215.9 x 355.6 mm)', width: 215.9, height: 355.6 },
    Tabloid: { label: 'US Tabloid (279.4 x 431.8 mm)', width: 279.4, height: 431.8 },
    AnsiC: { label: 'US ANSI C (431.8 x 558.8 mm)', width: 431.8, height: 558.8 },
    AnsiD: { label: 'US ANSI D (558.8 x 863.6 mm)', width: 558.8, height: 863.6 },
    AnsiE: { label: 'US ANSI E (863.6 x 1117.6 mm)', width: 863.6, height: 1117.6 },
    ArchC: { label: 'US ARCH C (457.2 x 609.6 mm)', width: 457.2, height: 609.6 },
    ArchD: { label: 'US ARCH D (609.6 x 914.4 mm)', width: 609.6, height: 914.4 },
    ArchE: { label: 'US ARCH E (914.4 x 1219.2 mm)', width: 914.4, height: 1219.2 },
    B5: { label: 'B5 (176 x 250 mm)', width: 176, height: 250 },
    Executive: { label: 'Executive (184.2 x 266.7 mm)', width: 184.2, height: 266.7 }
  };
  var JSPDF_PAPER_FORMATS = {
    A5: 'a5',
    A4: 'a4',
    A3: 'a3',
    A2: 'a2',
    A1: 'a1',
    Letter: 'letter',
    Legal: 'legal',
    Tabloid: 'tabloid',
    B5: 'b5',
    Executive: 'executive'
  };

  var TAG_TYPES = [
    { value: 'apriltag', label: 'AprilTag' },
    { value: 'circular', label: 'Circular Coded Target' }
  ];

  var APRILTAG_FAMILIES = [
    { value: '16h5', label: '16h5', modules: 4 },
    { value: '25h7', label: '25h7', modules: 5 },
    { value: '25h9', label: '25h9', modules: 5 },
    { value: '36h10', label: '36h10', modules: 6 },
    { value: '36h11', label: '36h11', modules: 6 },
    { value: 'circle21h7', label: 'Circle21h7', modules: 5 },
    { value: 'standard41h12', label: 'Standard41h12', modules: 7 },
    { value: 'standard52h13', label: 'Standard52h13', modules: 8 }
  ];

  var CIRCULAR_FAMILIES = [
    { value: 'metashape-12bit', label: 'Circular 12-bit', segments: 12, ringMode: 'single', polarity: 'normal' },
    { value: 'metashape-14bit', label: 'Circular 14-bit', segments: 14, ringMode: 'single', polarity: 'normal' },
    { value: 'metashape-16bit', label: 'Circular 16-bit', segments: 16, ringMode: 'single', polarity: 'normal' },
    { value: 'metashape-20bit', label: 'Circular 20-bit', segments: 20, ringMode: 'single', polarity: 'normal' },
    { value: 'rc-single-12bit', label: 'Single-ring 12-bit', segments: 12, ringMode: 'single', polarity: 'normal' },
    { value: 'rc-single-16bit', label: 'Single-ring 16-bit', segments: 16, ringMode: 'single', polarity: 'normal' },
    { value: 'rc-single-20bit', label: 'Single-ring 20-bit', segments: 20, ringMode: 'single', polarity: 'normal' },
    { value: 'rc-dual-12bit', label: 'Dual-ring 12-bit', segments: 12, ringMode: 'dual', polarity: 'normal' },
    { value: 'zephyr-16bit', label: 'Coded 16-bit', segments: 16, ringMode: 'single', polarity: 'normal' }
  ];

  var SHAPE_TYPES = [
    { value: 'cross', label: 'Cross' },
    { value: 'circle', label: 'Circle' },
    { value: 'circle-quartered', label: 'Circle 4-Segment' },
    { value: 'compass-marker', label: 'Compass Marker' },
    { value: 'grid', label: 'Grid' },
    { value: 'circle-grid', label: 'Circle Grid' },
    { value: 'rectangle', label: 'Rectangle' },
    { value: 'line', label: 'Line' }
  ];

  var METASHAPE_TEMPLATE_SETS = {
    'metashape-12bit': { bits: 12, count: 161 },
    'metashape-14bit': { bits: 14, count: 561 },
    'metashape-16bit': { bits: 16, count: 2001 },
    'metashape-20bit': { bits: 20, count: 26013 }
  };

  var SOFTWARE_PRESETS = {
    generic: {
      label: 'Generic / Manual',
      note: 'Manual mode. Use this when you want full control over target families.',
      allowedTypes: ['apriltag', 'circular'],
      families: {
        apriltag: ['16h5', '25h7', '25h9', '36h10', '36h11', 'circle21h7', 'standard41h12', 'standard52h13'],
        circular: ['metashape-12bit', 'metashape-14bit', 'metashape-16bit', 'metashape-20bit', 'rc-single-12bit', 'rc-single-16bit', 'rc-single-20bit', 'rc-dual-12bit', 'zephyr-16bit']
      },
      defaultType: 'apriltag',
      defaultFamily: {
        apriltag: '36h11',
        circular: 'metashape-16bit'
      }
    },
    metashape: {
      label: 'Metashape',
      note: 'Metashape marker families and normal-polarity circular sets.',
      allowedTypes: ['circular'],
      families: {
        circular: ['metashape-12bit', 'metashape-14bit', 'metashape-16bit', 'metashape-20bit']
      },
      defaultType: 'circular',
      defaultFamily: {
        circular: 'metashape-16bit'
      }
    },
    realitycapture: {
      label: 'Reality Scan',
      note: 'Reality Scan target families including AprilTag and circular marker sets.',
      allowedTypes: ['apriltag', 'circular'],
      families: {
        apriltag: ['16h5', '25h7', '25h9', '36h10', '36h11'],
        circular: ['rc-single-12bit', 'rc-single-16bit', 'rc-single-20bit', 'rc-dual-12bit']
      },
      defaultType: 'apriltag',
      defaultFamily: {
        apriltag: '36h11',
        circular: 'rc-single-16bit'
      }
    },
    zephyr: {
      label: '3DF Zephyr',
      note: 'Zephyr-targeted coded marker presets.',
      allowedTypes: ['apriltag', 'circular'],
      families: {
        apriltag: ['16h5', '25h9', '36h10', '36h11'],
        circular: ['zephyr-16bit']
      },
      defaultType: 'apriltag',
      defaultFamily: {
        apriltag: '36h11',
        circular: 'zephyr-16bit'
      }
    }
  };

  var FONT_OPTIONS = [
    'Space Grotesk',
    'IBM Plex Sans',
    'IBM Plex Mono',
    'Source Sans 3',
    'Work Sans',
    'Lora'
  ];

  var LOGO_DATA_URL = 'data:image/svg+xml;base64,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';

  var MAX_TAG_ID = 99999;
  var MM_PER_CM = 10;
  var MM_PER_IN = 25.4;
  var MM_PER_PT = MM_PER_IN / 72;
  var DEFAULT_NOISE_GRAIN_MM = 0.5;
  var DEFAULT_NOISE_CONTRAST = 1;
  var DEFAULT_NOISE_COLOR_A = '#505050';
  var DEFAULT_NOISE_COLOR_B = '#f7f8fa';
  var COMMAND_UNIT_OPTIONS = [
    { value: 'meter', label: '1 unit = 1 meter', mmPerUnit: 1000 },
    { value: '10cm', label: '1 unit = 10 cm', mmPerUnit: 100 },
    { value: '1cm', label: '1 unit = 1 cm', mmPerUnit: 10 },
    { value: '1mm', label: '1 unit = 1 mm', mmPerUnit: 1 },
    { value: 'yard', label: '1 unit = 1 yard', mmPerUnit: 914.4 },
    { value: 'foot', label: '1 unit = 1 foot', mmPerUnit: 304.8 },
    { value: 'inch', label: '1 unit = 1 inch', mmPerUnit: MM_PER_IN }
  ];
  var INFO_OVERLAY_DIMMED_OPACITY = 0.12;
  var CHECKER_TAG_PADDING_FACTOR = 0.25;
  var MAX_DISTANCE_OFFSET_MM = 500;
  var SESSION_STORAGE_KEY = 'scan_space_sbb_session_v1';
  var USED_TAGS_STORAGE_KEY = 'scan_space_sbb_used_tags_v1';
  var IGNORED_TAGS_STORAGE_KEY = 'scan_space_sbb_ignored_tags_v1';
  var SESSION_VERSION = 'sbb-v1';
  var GUIDE_SEEN_STORAGE_KEY = 'scan_space_sbb_intro_seen_v1';
  var SHARE_VERSION = 'sbb-v4';
  var SHARE_HASH_PREFIX = '#sbb=v4.';
  var MAX_SESSION_BYTES = 4.5 * 1024 * 1024;
  var TEMPLATE_STORAGE_KEY = 'scan_space_sbb_templates_v1';
  var TEMPLATE_VERSION = 'sbb-template-v1';
  var ATTRIBUTION_TEXT = 'Created using the Scan Space NZ Scale bar builder';
  var ATTRIBUTION_LINK = 'https://scanspace.nz/pages/scale';
  var ATTRIBUTION_PRINT_HINT = 'Print at "Actual Size" in printer settings.';
  var APRILTAG_QUIET_ZONE_TOTAL_FRACTION = 0.2;
  var METASHAPE_CIRCULAR_QUIET_ZONE_RADIUS_MULTIPLIER = 1.16;
  var SHARE_NUMBER_DECIMALS = 4;
  var SHARE_KEY_MAP = {
    softwarePreset: 'A',
    tagType: 'B',
    tagFamily: 'C',
    paperSize: 'D',
    paperOrientation: 'E',
    unitSystem: 'F',
    tagCount: 'G',
    tagSizeMm: 'H',
    spacingCm: 'I',
    corner: 'J',
    cornerMarginMm: 'K',
    cutMarginCm: 'L',
    printMarginMm: 'M',
    cutEditMode: 'N',
    cutShapeMode: 'O',
    cutShape: 'P',
    cutInsetsMm: 'Q',
    cutMoveUnlocked: 'R',
    steps: 'S',
    tags: 'T',
    tagSizesMm: 'U',
    layoutMode: 'V',
    originTagIndex: 'W',
    homePoint: 'c3',
    homeSetMode: 'c4',
    cutCircle: 'c5',
    showRelativeCoordinates: 'X',
    showGrid: 'Y',
    showDistances: 'Z',
    showReferenceMeasurements: 'a',
    checkerWidthCm: 'b',
    checkerHeightMm: 'c',
    commandUnitMode: 'c1',
    realityScanOutputMode: 'c2',
    references: 'd',
    snapEnabled: 'e',
    snapGridMm: 'f',
    snapGridDivisions: 'f1',
    showPlacementGuides: 'g',
    defaultFontFamily: 'h',
    overlayItems: 'i',
    background: 'j',
    distanceAnnotations: 'k',
    logoAutoPlacement: 'l',
    exportPdfSettings: 'd8',
    vertices: 'm',
    bbox: 'n',
    left: 'o',
    right: 'p',
    top: 'q',
    bottom: 'r',
    axis: 's',
    dir: 't',
    id: 'u',
    xMm: 'v',
    yMm: 'w',
    wMm: 'x',
    hMm: 'y',
    type: 'z',
    lengthMm: 'A0',
    cellWidthMm: 'B0',
    cellHeightMm: 'C0',
    rows: 'D0',
    rotationDeg: 'E0',
    style: 'F0',
    colorA: 'G0',
    colorB: 'H0',
    labelColor: 'I0',
    showLabel: 'J0',
    showScaleNumbers: 'J1',
    zIndex: 'K0',
    locked: 'L0',
    visible: 'M0',
    opacity: 'N0',
    text: 'O0',
    fontFamily: 'P0',
    fontSizeMm: 'Q0',
    fontSizePt: 'R0',
    color: 'S0',
    align: 'T0',
    preserveAspect: 'U0',
    mode: 'V0',
    imageDataUrl: 'W0',
    t: 'X0',
    normalOffsetMm: 'Y0',
    hidden: 'Z0'
    ,
    centerXMm: 'c6',
    centerYMm: 'c7',
    diameterMm: 'c8',
    shapeKind: 'c9',
    fillColor: 'd1',
    strokeColor: 'd2',
    strokeWidthMm: 'd3',
    ringCount: 'd4',
    spokeCount: 'd5',
    armRatio: 'd6',
    showUnitLabelInside: 'd7',
    dpi: 'd9',
    format: 'e8'
  };
  var SHARE_KEY_MAP_REVERSE = {};

  function indexByValue(entries) {
    var map = {};
    for (var i = 0; i < entries.length; i += 1) {
      map[entries[i].value] = entries[i];
    }
    return map;
  }

  var APRILTAG_BY_VALUE = indexByValue(APRILTAG_FAMILIES);
  var CIRCULAR_BY_VALUE = indexByValue(CIRCULAR_FAMILIES);
  var REALITYSCAN_CODEBOOKS = (typeof window !== 'undefined' && window.SBB_REALITYSCAN_CODEBOOKS && typeof window.SBB_REALITYSCAN_CODEBOOKS === 'object')
    ? window.SBB_REALITYSCAN_CODEBOOKS
    : { apriltag: {}, circular: {} };
  var CIRCULAR_LIBRARY_META = (function () {
    var source = (typeof window !== 'undefined' && window.SBB_CIRCULAR_LIBRARY_META && typeof window.SBB_CIRCULAR_LIBRARY_META === 'object')
      ? window.SBB_CIRCULAR_LIBRARY_META
      : {};
    var meta = {};
    Object.keys(source).forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(source, key)) {
        return;
      }
      var entry = source[key];
      meta[key] = (entry && typeof entry === 'object') ? Object.assign({}, entry) : {};
    });
    Object.keys(METASHAPE_TEMPLATE_SETS).forEach(function (key) {
      if (!meta[key]) {
        meta[key] = {};
      }
      if (!Number.isFinite(parseNumber(meta[key].count, NaN))) {
        meta[key].count = Math.max(0, Math.round(parseNumber(METASHAPE_TEMPLATE_SETS[key].count, 0)));
      }
    });
    return meta;
  })();
  Object.keys(SHARE_KEY_MAP).forEach(function (key) {
    SHARE_KEY_MAP_REVERSE[SHARE_KEY_MAP[key]] = key;
  });

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }


  function ScaleBarBuilder(rootElement) {
    this.root = rootElement;
    this.runtimeConfig = this.readRuntimeConfig();
    var createTemplate = sbbNamespace.createTemplate;
    var deepClone = sbbNamespace.deepClone;
    if (typeof deepClone !== 'function') {
      deepClone = function (value) {
        return JSON.parse(JSON.stringify(value));
      };
    }
    this.root.innerHTML = typeof createTemplate === 'function' ? createTemplate() : '';

    this.state = {
      softwarePreset: 'metashape',
      tagType: 'apriltag',
      tagFamily: '36h11',
      paperSize: 'A4',
      paperOrientation: 'portrait',
      unitSystem: 'metric',
      tagCount: 2,
      tagSizeMm: 50,
      spacingCm: 10,
      corner: 'center',
      cornerMarginMm: 14,
      cutMarginCm: 2,
      printMarginMm: 5,
      cutEditMode: 'auto',
      cutShapeMode: 'conform',
      cutShape: { vertices: [], bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 } },
      cutCircle: { centerXMm: 0, centerYMm: 0, diameterMm: 100, initialized: false },
      cutManual: { tool: 'edit', showGrid: true, closed: false, selectedPointIndex: -1, nodes: [] },
      cutInsetsMm: { left: 0, right: 0, top: 0, bottom: 0 },
      cutMoveUnlocked: false,
      steps: [
        { axis: 'horizontal', dir: 1 },
        { axis: 'horizontal', dir: 1 },
        { axis: 'horizontal', dir: 1 },
        { axis: 'horizontal', dir: 1 },
        { axis: 'horizontal', dir: 1 }
      ],
      tags: [],
      tagSizesMm: [],
      layoutMode: 'auto',
      selectedEntity: null,
      originTagIndex: 0,
      homePoint: null,
      homeSetMode: false,
      showRelativeCoordinates: false,
      showGrid: true,
      showDistances: true,
      showReferenceMeasurements: false,
      checkerWidthCm: 1,
      checkerHeightMm: 5,
      commandUnitMode: 'meter',
      realityScanOutputMode: 'ground',
      references: [],
      snapEnabled: true,
      snapGridMm: 5,
      snapGridDivisions: 1,
      showPlacementGuides: true,
      filterAprilTagCenters: true,
      defaultFontFamily: 'Space Grotesk',
      overlayItems: [],
      background: {
        mode: 'solid',
        color: '#ffffff',
        imageDataUrl: '',
        opacity: 0.35
      },
      backgroundNoise: {
        enabled: false,
        grainSizeMm: DEFAULT_NOISE_GRAIN_MM,
        contrast: DEFAULT_NOISE_CONTRAST,
        colorA: DEFAULT_NOISE_COLOR_A,
        colorB: DEFAULT_NOISE_COLOR_B
      },
      distanceAnnotations: {},
      logoAutoPlacement: true,
      exportPdfSettings: {
        dpi: 300,
        mode: 'hybrid-vector',
        format: 'pdf'
      },
      activeTool: 'select',
      viewZoom: 1,
      viewCenterXmm: null,
      viewCenterYmm: null,
      sidebarCollapsed: false,
      autosaveEnabled: true,
      lastSavedAt: null,
      sessionVersion: SESSION_VERSION,
      shareWarnings: []
    };

    this.tagImageCache = new Map();
    this.aprilMatrixCache = new Map();
    this.aprilFamilyCodeCache = {};
    this.imageCache = new Map();
    this.overlayAlphaCache = new Map();
    this.noiseTextureCache = null;
    this.metashapeCodesCache = {};
    this.hitRegions = [];
    this.dragState = null;
    this.view = null;
    this.pixelRatio = 1;
    this.pointerDownEntity = null;
    this.inlineTextEditing = null;
    this.idCorrections = [];
    this.overlayCounter = 1;
    this.referenceCounter = 1;
    this.entityClipboard = null;
    this.infoOverlayId = 'overlay-info';
    this.logoOverlayId = 'overlay-logo';
    this.isExportRender = false;
    this.sceneVisualAlpha = 1;
    this.saveDebounceTimer = null;
    this.suspendAutosave = true;
    this.undoStack = [];
    this.redoStack = [];
    this.maxHistorySteps = 80;
    this.suspendHistory = true;
    this.lastHistorySerialized = '';
    this._managedListeners = [];
    this._destroyed = false;
    this.templateLibrary = [];
    this.templateLibraryById = {};
    this.templateCounter = 1;
    this.templateSelectSignature = '';
    this.selectedTemplateId = '';
    this.validTagIdListCache = {};
    this.defaultState = null;
    this.shareBaseState = null;
    this.usedTagRegistryByScope = {};
    this.ignoredTagIdRegistryByScope = {};
    this.imagePickerState = {
      mode: 'upload',
      sourceType: null,
      sourceValue: '',
      file: null,
      previewValid: false,
      previewObjectUrl: ''
    };
    this.guideSteps = [];
    this.guideActive = false;
    this.guideStepIndex = 0;
    this.guideHighlightElement = null;
    this.guideMode = 'quick';
    this.guideAnimationTimer = null;
    this.layerDragState = null;
    this.manualCutPreviewPointerMm = null;
    this.isExportModalOpen = false;
    this.exportPreviewDebounceTimer = null;
    this.exportPreviewRenderToken = 0;
    this.exportDpiInputDebounceTimer = null;
    this.keyboardShortcutScope = false;

    this.bindElements();
    this.loadTagRegistriesFromLocal();
    this.applyHostThemeTokens();
    this.initTopShelfControls();
    this.populateSelects();
    this.refreshPresetDependentOptions(true);
    this.ensureTagCollection(true);
    this.initDefaultOverlays();
    this.defaultState = deepClone(this.state);
    this.shareBaseState = this.buildShareStateSnapshot(this.defaultState, true);
    this.loadTemplateLibrary();
    this.restoreInitialState();
    this.syncControlsFromState();
    this.syncDynamicRows();
    this.attachEvents();
    this.applySidebarCollapsedState();
    this.updateViewportLayout();
    this.resizeCanvas();
    this.suspendAutosave = false;
    this.suspendHistory = false;
    this.render();
    this.initializeHistory();
    this.maybeStartGuideOnFirstVisit();
  }
  // REGION: Event Binding (moved to scale-bar-builder-events.js)
  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  sbbNamespace.ScaleBarBuilder = ScaleBarBuilder;
  sbbNamespace.clamp = clamp;
  sbbNamespace.parseNumber = parseNumber;
  sbbNamespace.maxTagId = MAX_TAG_ID;
  sbbNamespace.mmPerCm = MM_PER_CM;
  sbbNamespace.mmPerIn = MM_PER_IN;
  sbbNamespace.sessionStorageKey = SESSION_STORAGE_KEY;
  sbbNamespace.sessionVersion = SESSION_VERSION;
  sbbNamespace.maxSessionBytes = MAX_SESSION_BYTES;
  sbbNamespace.guideSeenStorageKey = GUIDE_SEEN_STORAGE_KEY;
  sbbNamespace.usedTagsStorageKey = USED_TAGS_STORAGE_KEY;
  sbbNamespace.ignoredTagsStorageKey = IGNORED_TAGS_STORAGE_KEY;
  sbbNamespace.shareVersion = SHARE_VERSION;
  sbbNamespace.shareHashPrefix = SHARE_HASH_PREFIX;
  sbbNamespace.shareNumberDecimals = SHARE_NUMBER_DECIMALS;
  sbbNamespace.shareKeyMap = SHARE_KEY_MAP;
  sbbNamespace.shareKeyMapReverse = SHARE_KEY_MAP_REVERSE;
  sbbNamespace.templateStorageKey = TEMPLATE_STORAGE_KEY;
  sbbNamespace.templateVersion = TEMPLATE_VERSION;
  sbbNamespace.commandUnitOptions = COMMAND_UNIT_OPTIONS;
  sbbNamespace.paperSizes = PAPER_SIZES;
  sbbNamespace.jsPdfPaperFormats = JSPDF_PAPER_FORMATS;
  sbbNamespace.softwarePresets = SOFTWARE_PRESETS;
  sbbNamespace.mmPerPt = MM_PER_PT;
  sbbNamespace.checkerTagPaddingFactor = CHECKER_TAG_PADDING_FACTOR;
  sbbNamespace.tagTypes = TAG_TYPES;
  sbbNamespace.shapeTypes = SHAPE_TYPES;
  sbbNamespace.aprilTagFamilies = APRILTAG_FAMILIES;
  sbbNamespace.circularFamilies = CIRCULAR_FAMILIES;
  sbbNamespace.logoDataUrl = LOGO_DATA_URL;
  sbbNamespace.fontOptions = FONT_OPTIONS;
  sbbNamespace.aprilTagByValue = APRILTAG_BY_VALUE;
  sbbNamespace.circularByValue = CIRCULAR_BY_VALUE;
  sbbNamespace.realityScanCodebooks = REALITYSCAN_CODEBOOKS;
  sbbNamespace.circularLibraryMeta = CIRCULAR_LIBRARY_META;
  sbbNamespace.defaultNoiseGrainMm = DEFAULT_NOISE_GRAIN_MM;
  sbbNamespace.defaultNoiseContrast = DEFAULT_NOISE_CONTRAST;
  sbbNamespace.defaultNoiseColorA = DEFAULT_NOISE_COLOR_A;
  sbbNamespace.defaultNoiseColorB = DEFAULT_NOISE_COLOR_B;
  sbbNamespace.attributionText = ATTRIBUTION_TEXT;
  sbbNamespace.attributionLink = ATTRIBUTION_LINK;
  sbbNamespace.attributionPrintHint = ATTRIBUTION_PRINT_HINT;
  sbbNamespace.apriltagQuietZoneTotalFraction = APRILTAG_QUIET_ZONE_TOTAL_FRACTION;
  sbbNamespace.metashapeCircularQuietZoneRadiusMultiplier = METASHAPE_CIRCULAR_QUIET_ZONE_RADIUS_MULTIPLIER;
  sbbNamespace.metashapeTemplateSets = METASHAPE_TEMPLATE_SETS;
  sbbNamespace.infoOverlayDimmedOpacity = INFO_OVERLAY_DIMMED_OPACITY;
  sbbNamespace.maxDistanceOffsetMm = MAX_DISTANCE_OFFSET_MM;
})();
